import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

// init history slider
const historySlider = new Swiper('.history-block__timeline .swiper', {
	modules: [Navigation, Pagination],
	autoHeight: true,
	slidesPerView: 1,
	spaceBetween: 20,
	navigation: {
		nextEl: '.history-block__timeline .swiper__next',
		prevEl: '.history-block__timeline .swiper__prev',
	},
	pagination: {
		el: document.querySelector('.history-block__timeline-nav').querySelector('.swiper-pagination'),
		type: 'progressbar',
	},
	breakpoints: {
		480: {
			slidesPerView: 1,
			spaceBetween: 30,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 40,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 40,
		}
	}
});

const historyFilters = document.querySelectorAll('.history-filter');
if (historyFilters) {
	historyFilters.forEach((filter) => {
		filter.addEventListener('click', (event) => {
			document.querySelector('.history-filter.active').classList.remove('active');
			filter.classList.add('active');
			historyFilter(historySlider, filter);
		});
	});
}

// insights filter
function historyFilter(swiper, filter) {
	// check for hidden slides and add back into slider if they match selected filter
	let swiperHiddenSlides = swiper.wrapperEl.querySelectorAll('.non-swiper-slide');
	if (swiperHiddenSlides) {
		swiperHiddenSlides.forEach((slide) => {
			if (slide.getAttribute('data-category') == filter.getAttribute('data-filter') || filter.getAttribute('data-filter') == 'all') {
				slide.classList.remove('non-swiper-slide');
				slide.classList.add('swiper-slide');
				slide.style.display = 'initial';
			}
		});
	}
	// hide slides that don't match selected filter
	swiper.slides.forEach((slide) => {
		if (filter.getAttribute('data-filter') == 'all') {
			// do nothing
		} else if (slide.getAttribute('data-category') != filter.getAttribute('data-filter')) {
			slide.classList.remove('swiper-slide');
			slide.classList.add('non-swiper-slide');
			slide.style.display = 'none';
		}
	});
	swiper.update();
	swiper.slideTo(0);
	let swiperActiveSlides = swiper.wrapperEl.querySelectorAll('.swiper-slide:not(.non-swiper-slide)');
	if (swiperActiveSlides.length <= 3) {
		swiper.el.classList.add('swiper-all-visible');
	} else {
		swiper.el.classList.remove('swiper-all-visible');
	}
}
